import { render, staticRenderFns } from "./SvgHomePartnerPicto.vue?vue&type=template&id=66c2d4fe&scoped=true"
import script from "./SvgHomePartnerPicto.vue?vue&type=script&lang=js"
export * from "./SvgHomePartnerPicto.vue?vue&type=script&lang=js"
import style0 from "./SvgHomePartnerPicto.vue?vue&type=style&index=0&id=66c2d4fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c2d4fe",
  null
  
)

export default component.exports